import React from 'react';
import clsx from 'clsx';
import usePersonStore from '../../store/personStore';

const Container = ({ children, className = '', props }) => {
  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
  );

  return (
    <section
      className={clsx('container mx-auto lg:py-10 py-6 scrollbar', className)}
      style={{
        height: showRetailDashboard ? 'calc(100vh - 150px)' : 'calc(100vh - 76px)',
        }}
      {...props}
    >
      {children}
    </section>
  );
};

export default Container;
